module.exports = __webpack_public_path__ + "img/xssk.e631bc79.png";